import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const VersionWallMobileSchema = z.string()

export const VersionWallSchema = z.object({
  mobile: VersionWallMobileSchema,
})

export type VersionWallStore = z.infer<typeof VersionWallSchema>

export function useVersionWallParameterStore() {
  return useMesaParameterStore('version_wall')
}
